import { includes, filter } from 'lodash';

export const isUserServicesList = (services, ids) => {
  if (services && services.length > 0) {
    return filter(services, (service) => includes(ids, service)).length > 0;
  }
  return false;
};
